<div class="chips" [class.fw-700]="bold"  [class.has-padding]="spaced" [class.text-center]="spaced" [class.square]="square" [ngClass]="getClass()">
	<ng-content ></ng-content>
</div>
